export const menuGroups = [
  {
    title: "Operaciones",
    items: [
      { path: "/BusinessUnit", label: "Unidad de negocio" },
      { path: "/Products", label: "Productos y features" },
      { path: "/PackagesView", label: "Paquetes" },
      { path: "/Facturacion", label: "Facturación" },
    ],
  },
  {
    title: "Contabilidad",
    items: [
      { path: "/reporteCostos", label: "Reporte de costos" },
      { path: "/additionalCost", label: "Costos independientes" },
      { path: "/contador", label: "Reporte facturación" },
    ],
  },
];
